import type { Dictionary } from "../types/Dictionary";
import type { AnyFn, fn } from "../types/fn";
import type { valueOf } from "../types/value-of";

// array
export function map<I, O>(array: I[], convert: fn<[I, number, I[]], O>): O[];

// dictionaries
export function map<S extends Dictionary, F extends fn<[valueOf<S>, Exclude<keyof S, number>, S], any>>(
  dic: S,
  convert: F,
): Record<keyof S, ReturnType<F>>;

// ---- implementation -----
export function map(struct: any, convert: AnyFn) {
  // if a functor, use map method
  if (struct?.map instanceof Function) return struct.map(convert);

  // fallback to regular dictionary
  const entries = Object.entries(struct as object);
  const convertedEntries = entries.map(([key, value]) => {
    const convertedValue = convert(value, key, struct);
    return [key, convertedValue];
  });

  return Object.fromEntries(convertedEntries);
}
